import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SuppressionList } from '@/pages/super-admin/suppression-list';

const suppressionListSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(50),
	search: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/suppression-list')({
	component: SuppressionList,
	validateSearch: suppressionListSearchSchema,
});
